import { inject, Injector, effect } from '@angular/core';
import { assertInjector } from 'ngxtension/assert-injector';
function injectAutoEffect(injector) {
  return assertInjector(injectAutoEffect, injector, () => {
    const assertedInjector = inject(Injector);
    const injectorOptions = {
      injector: assertedInjector
    };
    return (autoEffectCallback, options = {}) => {
      return effect(onCleanup => {
        const maybeCleanup = autoEffectCallback(assertedInjector);
        if (typeof maybeCleanup === 'function') {
          onCleanup(() => maybeCleanup());
        }
      }, Object.assign(options, injectorOptions));
    };
  });
}

/**
 * Generated bundle index. Do not edit.
 */

export { injectAutoEffect };
